import { WhatsAppIcon } from 'components/icons/WhatsAppIcon';
import { buildWaLink } from '../api/getProducts';

export function CtaBanner() {
  return (
    <section
      id="contact"
      className="bg-[radial-gradient(ellipse_60%_80%_at_50%_50%,rgba(0,229,160,0.06)_0%,transparent_70%)] px-4 py-20 text-center sm:px-8"
    >
      <h2 className="mx-auto max-w-xl text-[clamp(1.5rem,3.5vw,2.2rem)] font-black leading-tight">
        Can&apos;t find what you&apos;re looking for? Tell us what gadget you need and we&apos;ll
        source it.
      </h2>
      <p className="mt-4 text-text-muted">
        We source on request — phones, laptops, accessories and more.
      </p>

      <a
        href={buildWaLink("Hi Chikwafu, I'm looking for a specific item")}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-accent px-6 py-3 text-sm font-extrabold text-black transition-all hover:-translate-y-0.5 hover:bg-accent-dim"
      >
        <WhatsAppIcon />
        Message us on WhatsApp
      </a>
    </section>
  );
}
